import {
  COMPONENT_INSTANCE_UNLINKED,
  COMPONENT_INSTANCE_UNLINK_ATTEMPTED,
} from '@packages/systems/designer/actions';
import type {DesignerActionFromCreator} from '@packages/systems/designer/flux';
import {createAction} from '@packages/utilities/create-action';
import type {ComponentInstanceUnlinkedPayload} from './types';

export const componentInstanceUnlinked = createAction<
  typeof COMPONENT_INSTANCE_UNLINKED,
  ComponentInstanceUnlinkedPayload
>(COMPONENT_INSTANCE_UNLINKED);

export type ComponentInstanceUnlinkedAction = DesignerActionFromCreator<
  typeof componentInstanceUnlinked
>;

export const componentInstanceUnlinkFailed = createAction<
  typeof COMPONENT_INSTANCE_UNLINK_ATTEMPTED
>(COMPONENT_INSTANCE_UNLINK_ATTEMPTED);

export type componentInstanceUnlinkFailedAction = DesignerActionFromCreator<
  typeof componentInstanceUnlinkFailed
>;
